export default "__VITE_ASSET__BC7GNyN1__"